module.exports = __webpack_public_path__ + "static/media/hyerim-jeong-portrait.dbee0b02.png";